import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import { gaEvent } from "../../models/ga";
import useFacility from "../../../utils/hooks/useFacility";
import BasketNavButton from "../../../features/NavBar/features/BasketNavButton";

const LimitedTicketShapePage: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration.componentList);
  const messageShapes = useSelector((state: State) => state.config.configuration.message_shapes);

  const { shapeGroup, requestGetShapeGroup } = useTickets();
  const facilityIds = useFacility();

  useEffect(() => {
    requestGetShapeGroup();
    if (facilityIds === "273") {
      // gaEvent("Bilety na basen", "page_view", "", "");
    }
    

  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div className="headline">
          {saleConfiguration && (<React.Fragment>
            {saleConfiguration.map((item) => (
            <React.Fragment>{item.id === "Shapes" && <h1>{item.name}</h1>}</React.Fragment>
          ))}
          </React.Fragment>)}
       
          <div className="line"></div>

          {messageShapes && (
            <React.Fragment>
              {messageShapes.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: messageShapes }}></article>
                </div>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
        {shapeGroup && (
          <React.Fragment>
            {shapeGroup.map((item, index) => (
              <div key={index}>
                <LimitedTicketBlock item={item} sortType="shapeGroup" />
              </div>
            ))}
          </React.Fragment>
        )}
      </div>


    </React.Fragment>
  );
};

export default LimitedTicketShapePage;
